/**
 * iOS/Android status bar: WebView'i status bar (ve Dynamic Island) altından başlat.
 * overlay=false → içerik saat/çentik ile çakışmaz. Yalnızca native'de çalışır; web'de no-op.
 */
import { Capacitor } from '@capacitor/core';

const APP_DARK = '#050505';

export async function initCapacitorStatusBar() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    // İçerik status bar'ın ALTINDA kalsın (üst üste binmeyi engeller)
    await StatusBar.setOverlaysWebView({ overlay: false });
    // Koyu tema → açık (beyaz) status bar ikonları
    await StatusBar.setStyle({ style: Style.Dark });
    // Android: status bar arka planı app rengiyle aynı (iOS'ta no-op)
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: APP_DARK });
    }
  } catch (e) {
    console.warn('[statusBar] init failed', e);
  }
}
